<template>
  <div 
    class="px-5 mt-8">
    <v-dialog v-model="dialog.success"
      width="350">
      <v-card 
        class="border-radius pa-2">
        <v-card-text>
          <v-img 
            width="125"
            height="125"
            alt="kominfoklaten" 
            :src="require('@/assets/icon/info_berhasil.png')"
            class="ma-auto my-6">
            <template v-slot:placeholder>
              <v-row
                class=" "
                align="center"
                justify="center">
                <v-progress-circular 
                  size="20"
                  indeterminate 
                  :color="set_color">
                </v-progress-circular>
              </v-row>
            </template>
          </v-img>

          <div
            class="body-1 text-center line-text-second">
            <div>
              Terima kasih, Pengiriman
            </div>

            <div>
              telah berhasil dikonfirmasi!
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.status"
      @keydown.esc="dialog.status = false"
      :fullscreen="dialog.fullscreen"
      width="500"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="pa-8 pt-6">
        <v-card-title 
          class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
          
          Mengubah Status

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#718EBF">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon> -->

          <v-icon 
            @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>
        
        <!-- <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-text 
          class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
          Apakah Anda yakin mengkonfirmasi pengiriman surat jalan ini?


          <div v-if="message.error.length > 0"
            class="text-left mt-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>


        <!-- <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-actions
          class="pa-0 pt-4">
          <v-spacer/>

          <v-btn
            rounded
            @click="save()"
            :loading="process.form"
            :disabled="process.form"
            width="190"
            height="45"
            elevation="0"
            color="#1814F3"
            class="fs-16 white--text text-capitalize border-radius">
            Ya, {{ message.status }}
          </v-btn>

          <!-- <v-btn
            rounded
            width="120"
            @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
            :disabled="process.status"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.bukti"
      @keydown.esc="dialog.bukti = false"
      v-if="dialog.bukti"
      :fullscreen="dialog.fullscreen"
      width="600"
      persistent
      scrollable>
      <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="">
        <v-card-title 
          class="d-flex align-center pb-4 text-right popup-header fs-18 font-weight-bold">
          
          Bukti Pengiriman

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#718EBF">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.bukti = false; dialog.fullscreen = false; selected.bukti = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon> -->

          <v-icon 
            @click="dialog.bukti = false; dialog.fullscreen = false;"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>
        
        <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/>

        <v-card-text 
        class="body-1 font-weight-light text-first line-text-second my-0" v-if="selected.detail.length > 0">
          <table style="width: auto;">
            <tr>
              <td class="fs-13 py-1">
                No BPB
              </td>
              <td style="width: 40px" class="fs-13 text-center">
                : 
              </td>
              <td class="fs-13 text-left">
                {{ selected.detail[0].bpb_number }}
              </td>
            </tr>
            <tr>
              <td class="fs-13 py-1">
                Nama Toko
              </td>
              <td style="width: 40px" class="fs-13 text-center">
                : 
              </td>
              <td class="fs-13 text-left">
                {{ selected.detail[0].store_name }}
              </td>
            </tr>
            <tr>
              <td class="fs-13 py-1">
                No. Order
              </td>
              <td style="width: 40px" class="fs-13 text-center">
                : 
              </td>
              <td class="fs-13 text-left">
                {{ selected.detail[0].orders_number }}
              </td>
            </tr>
          </table>

          <div class="mt-2" v-for="(item, index) in selected.detail[0].foto_bukti_json" :key="index">
            <img 
              :src="item"
              alt="Mitra Warung" 
              style="width: 100%; height: 100%; border: 2px dashed #e0e0e0; border-radius: 8px !important;" />
          </div>

          <v-card-text
            v-if="selected.detail[0].foto_bukti_json.length === 0"
            class="pb-0 my-4" style="height: 200px; display: flex; align-items: center; justify-content: center;">
            <div class="text-center">
              <v-img 
                class="mx-auto"
                contain
                alt="vuetify"
                :width="90"
                :height="90"
                :src="require('@/assets/image/empty.png')">
                <!-- <template v-slot:placeholder>
                  <v-row
                    class=" "
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template> -->
              </v-img>
              <div class="mt-3 fs-16">
                Belum Ada Data Foto
              </div>
            </div>
          </v-card-text>

        </v-card-text>


        <!-- <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-actions
          class="">
          <v-spacer/>

          <v-btn
            rounded
            width="120"
            @click="dialog.bukti = false; dialog.fullscreen = false;"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-22 font-weight-bold mb-2">
            Detail Surat Jalan
          </div>

          <v-row
            class="mt-0">
            <v-col 
              cols="12"
              class="py-0">

              <v-row>
                <v-col cols="12" md="5">
                  <v-card 
                    flat
                    style="border-radius: 8px; border: 1px solid #E7E7E7;">
                    <v-card-text
                      v-if="process.load" 
                      class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <div class="mb-2 title">
                          Mohon Tunggu...
                        </div>
                        <v-progress-circular
                          indeterminate
                        ></v-progress-circular>
                      </div>
                    </v-card-text>

                    <v-card-text v-if="!process.load && Object.keys(detail).length > 0" class="py-0">
                      <v-row>
                        <v-col cols="6">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              No. Surat Jalan
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ detail.number }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              Nama Driver
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ detail.driver_name }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              Nama Kendaraan
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ detail.vehicle_name }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              Tanggal Pengiriman
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ detail.date | date }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              Status
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ detail.status == 'pengiriman' ? 'Pengiriman' : detail.status == 'diterima' ? 'Menunggu Konfirmasi' : detail.status == 'Set Order' ? 'Menunggu Pengiriman' : 'Pengiriman Terkonfirmasi' }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div>
                            <div class="fs-14" style="margin-bottom: 1px;">
                              Catatan
                            </div>
                            <div class="fs-16 label-input font-weight-bold">
                              {{ detail.note === '' ? '-' : detail.note }}
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="12" md="7">
                  <v-card 
                    flat
                    style="border-radius: 8px; border: 1px solid #E7E7E7;">
                    <v-card-text
                      v-if="process.load" 
                      class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <div class="mb-2 title">
                          Mohon Tunggu...
                        </div>
                        <v-progress-circular
                          indeterminate
                        ></v-progress-circular>
                      </div>
                    </v-card-text>

                    <v-card-text v-if="!process.load && Object.keys(detail).length > 0" class="pt-0">
                      <div class="fs-18 input-label font-weight-bold pt-2 pb-3 black--text">
                        Summary
                      </div>
                      <div style="overflow-x: auto; min-height: 256px;">
                        <table style="border-radius: 10px; width: 100%; border: thin solid #E6EFF5;" class="table">
                          <tr>
                            <th :style="'left: 0px;'" class="text-left black--text fs-14 font-weight-bold pa-2" style="z-index: 2; position: sticky; background-color: white !important; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Nama Barang</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">{{ detail.status === 'Set Order' ? 'Akan dikirim' : 'Dikirim' }}</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Diterima</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Dikembalikan</th>
                            <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Rusak</th>
                          </tr>
                          <tr v-for="(item, index) in summary" :key="index">
                            <td :style="'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="left: 0px; z-index: 2; position: sticky; background-color: white !important; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5; min-width: 200px; width: 200px;">{{ item.varian_name }}</td>
                            <td :style="'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                              <div v-if="item.total_qty_pcs*1 > 0">
                                {{ item.total_qty_pcs }} Pcs
                              </div>
                              <div v-if="item.total_qty_lusin*1 > 0">
                                {{ item.total_qty_lusin }} Lusin
                              </div>
                              <div v-if="item.total_qty_dus*1 > 0">
                                {{ item.total_qty_dus | number }} {{ (item.total_qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                              <div v-else>
                                {{ item.total_qty_dus | number }} {{ (item.total_qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                            </td>
                            <td :style="'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                              <div v-if="item.total_qty_pcs*1 > 0">
                                {{ item.total_qty_pcs_diterima }} Pcs
                              </div>
                              <div v-if="item.total_qty_lusin*1 > 0">
                                {{ item.total_qty_lusin_diterima }} Lusin
                              </div>
                              <div v-if="item.total_qty_dus*1 > 0">
                                {{ item.total_qty_dus_diterima | number }} {{ (item.total_qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                              <div v-else>
                                {{ item.total_qty_dus_diterima | number }} {{ (item.total_qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                            </td>
                            <td :style="'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                              <div v-if="item.total_qty_pcs*1 > 0">
                                {{ item.total_qty_pcs_return }} Pcs
                              </div>
                              <div v-if="item.total_qty_lusin*1 > 0">
                                {{ item.total_qty_lusin_return }} Lusin
                              </div>
                              <div v-if="item.total_qty_dus*1 > 0">
                                {{ item.total_qty_dus_return | number }} {{ (item.total_qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                              <div v-else>
                                {{ item.total_qty_dus_return | number }} {{ (item.total_qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                            </td>
                            <td :style="'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                              <div v-if="item.total_qty_pcs*1 > 0">
                                {{ item.total_qty_pcs_rusak }} Pcs
                              </div>
                              <div v-if="item.total_qty_lusin*1 > 0">
                                {{ item.total_qty_lusin_rusak }} Lusin
                              </div>
                              <div v-if="item.total_qty_dus*1 > 0">
                                {{ item.total_qty_dus_rusak | number }} {{ (item.total_qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                              <div v-else>
                                {{ item.total_qty_dus_rusak | number }} {{ (item.total_qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </v-card-text>  
                  </v-card>
                </v-col>
              </v-row>

              <v-card v-if="Object.keys(detail).length > 0" flat style="border-radius: 8px; border: 1px solid #E7E7E7; " class="mt-5">
                <v-card-text>
                  <div class="fs-18 input-label font-weight-bold pt-2 pb-3 black--text">
                    Data BPB
                  </div>
                  <div style="margin: auto;">

                    <div style="overflow-x: auto; min-height: 250px;">
                      <table style="border-radius: 10px; width: 100%; border: thin solid #E6EFF5;" class="table">
                        <tr>
                          <th :style="'left: 0px;'" class="text-left black--text fs-14 font-weight-bold pa-2" style="z-index: 2; position: sticky; background-color: white !important; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">No BPB</th>
                          <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Tgl Order</th>
                          <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Nama Toko</th>
                          <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Nama Sales</th>
                          <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Wilayah</th>
                          <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Alamat</th>
                          <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Nama Barang</th>
                          <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">{{ detail.status === 'Set Order' ? 'Akan dikirim' : 'Dikirim' }}</th>
                          <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Diterima</th>
                          <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Dikembalikan</th>
                          <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Rusak</th>
                          <th class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Bukti Pengiriman</th>
                          <th v-if="detail.status === 'diterima'" class="text-left black--text fs-14 font-weight-bold pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5; border-left: thin solid #E6EFF5;">Aksi</th>
                        </tr>
                        <tr v-for="(item, index) in data_bpb" :key="index">
                          <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="left: 0px; z-index: 2; position: sticky; background-color: white !important; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5; min-width: 200px; width: 200px;">{{ item.bpb_number }}</td>
                          <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.orders_number }}</td>
                          <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.store_name }}</td>
                          <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.sales_name }}</td>
                          <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.wilayah }}</td>
                          <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 300px; min-width: 300px; max-width: 300px; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                            {{ item.shipping_province }}, {{ item.shipping_city }}, {{ item.shipping_subdistrict }}, {{ item.shipping_village }}
                          </td>
                          <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.varian_name }}</td>
                          <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                            <div v-if="item.qty_pcs*1 > 0">
                              {{ item.qty_pcs }} Pcs
                            </div>
                            <div v-if="item.qty_lusin*1 > 0">
                              {{ item.qty_lusin }} Lusin
                            </div>
                            <div v-if="item.qty_dus*1 > 0">
                              {{ item.qty_dus | number }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                            </div>

                            <div v-else>
                              {{ item.qty_dus | number }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                            </div>
                          </td>
                          <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                            <div v-if="item.qty_pcs*1 > 0">
                              {{ item.qty_pcs_diterima }} Pcs
                            </div>
                            <div v-if="item.qty_lusin*1 > 0">
                              {{ item.qty_lusin_diterima }} Lusin
                            </div>
                            <div v-if="item.qty_dus*1 > 0">
                              {{ item.qty_dus_diterima | number }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                            </div>
                            <div v-else>
                              {{ item.qty_dus_diterima | number }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                            </div>
                          </td>
                          <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                            <div v-if="detail.status === 'diterima'" style="width: 150px;">
                              <div v-if="item.qty_pcs*1 > 0">
                                <v-currency-field
                                  filled
                                  rounded
                                  dense
                                  solo
                                  v-on:change="item.qty_pcs_diterima = (item.qty_tetap*1) - (item.qty_pcs_return*1) - (item.kirim_qty_dus_rusak*1)"
                                  :allowNegative="false"
                                  color="#718EBF"
                                  placeholder="Qty Rusak"
                                  hide-details
                                  v-model="item.qty_pcs_return"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </div>
                              <div v-if="item.qty_dus*1 > 0">
                                <v-currency-field
                                  filled
                                  rounded
                                  dense
                                  solo
                                  @input="
                                    item.qty_dus_return = $event;
                                    const tetap = parseFloat(item.qty_tetap);
                                    const rusak = parseFloat(item.kirim_qty_dus_rusak);
                                    const kembali = parseFloat(item.qty_dus_return);

                                    item.qty_dus_diterima =
                                      (!isNaN(tetap) ? tetap : (item.qty_dus_muat*1)) -
                                      (rusak) -
                                      (!isNaN(kembali) ? kembali : 0);
                                  "
                                  :allowNegative="false"
                                  color="#718EBF"
                                  placeholder="Qty Dikembalikan"
                                  hide-details
                                  v-model="item.qty_dus_return"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </div>
                              <div v-else>
                                <v-currency-field
                                  filled
                                  rounded
                                  dense
                                  solo
                                  @input="
                                    item.qty_dus_return = $event;
                                    const tetap = parseFloat(item.qty_tetap);
                                    const rusak = parseFloat(item.kirim_qty_dus_rusak);
                                    const kembali = parseFloat(item.qty_dus_return);

                                    item.qty_dus_diterima =
                                      (!isNaN(tetap) ? tetap : (item.qty_dus_muat*1)) -
                                      (rusak) -
                                      (!isNaN(kembali) ? kembali : 0);
                                  "
                                  :allowNegative="false"
                                  color="#718EBF"
                                  placeholder="Qty Dikembalikan"
                                  hide-details
                                  v-model="item.qty_dus_return"
                                  :error-messages="errors"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </div>
                            </div>
                            <div v-else>
                              <div v-if="item.qty_pcs*1 > 0">
                                {{ item.qty_pcs_return }} Pcs
                              </div>
                              <div v-if="item.qty_lusin*1 > 0">
                                {{ item.qty_lusin_return }} Lusin
                              </div>
                              <div v-if="item.qty_dus*1 > 0">
                                {{ item.qty_dus_return }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                            </div>
                          </td>
                          <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2" style="width: 1px; white-space: nowrap; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                            <div v-if="detail.status === 'diterima'" style="width: 150px;">
                              <v-currency-field
                                filled
                                rounded
                                dense
                                solo
                                @input="
                                    item.kirim_qty_dus_rusak = $event;
                                    const tetap = parseFloat(item.qty_tetap);
                                    const rusak = parseFloat(item.kirim_qty_dus_rusak);
                                    const kembali = parseFloat(item.qty_dus_return);

                                    item.qty_dus_diterima =
                                      (!isNaN(tetap) ? tetap : (item.qty_dus_muat*1)) -
                                      (kembali) -
                                      (!isNaN(rusak) ? rusak : 0);
                                  "
                                :allowNegative="false"
                                color="#718EBF"
                                placeholder="Qty Rusak"
                                hide-details
                                v-model="item.kirim_qty_dus_rusak"
                                :error-messages="errors"
                                required
                                style="border-radius: 10px;">
                              </v-currency-field>
                            </div>
                            <div v-else>
                              <div v-if="item.qty_dus*1 > 0">
                                {{ item.kirim_qty_dus_rusak | number }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                              </div>
                            </div>
                          </td>
                          <td :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2 text-center" style="width: 100%; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="dialog.bukti = true; selected.detail = [item];"
                                  min-width="28"
                                  small
                                  rounded
                                  color="green"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-information-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Bukti Visit</span>
                            </v-tooltip>
                          </td>
                          <td v-if="detail.status === 'diterima'" :style="item.is_store_closed === '1' ? 'background: #fff1f1' : 'background: #fff'" class="text-left black--text label-input fs-12 pa-2 text-center" style="width: 100%; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  min-width="28"
                                  small
                                  :loading="process.update_bpb && form_update_bpb.bpb_detail_id === item.bpb_detail_id"
                                  :disabled="(process.update_bpb && form_update_bpb.bpb_detail_id === item.bpb_detail_id) || 
                                  (toNumber(item.qty_dus_return) + toNumber(item.kirim_qty_dus_rusak) + toNumber(item.qty_dus_diterima) !== toNumber(item.qty_dus_muat))"

                                  @click="
                                    form_update_bpb.bpb_detail_id = item.bpb_detail_id;
                                    form_update_bpb.qty_pcs_diterima = item.qty_pcs_diterima;
                                    form_update_bpb.qty_dus_diterima = item.qty_dus_diterima;
                                    form_update_bpb.qty_pcs_return = item.qty_pcs_return;
                                    form_update_bpb.qty_dus_return = item.qty_dus_return;
                                    form_update_bpb.kirim_qty_dus_rusak = item.kirim_qty_dus_rusak;
                                    form_update_bpb.bpb_id = item.bpb_id;
                                    form_update_bpb.is_close = item.is_store_closed === '1' ? '1' :  item.qty_dus*1 === item.qty_dus_return*1 || item.qty_dus*1 === item.kirim_qty_dus_rusak*1 ? '1' : '0';
                                    saveUpdateBpb(index)
                                  "
                                  rounded
                                  :color="item.is_checked ? 'primary' : 'orange'"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1"
                                  style="font-weight: 600; border-radius: 6px;">
                                  {{ !item.is_checked ? 'Cek Data' : 'Sudah Cek' }}
                                </v-btn>
                              </template>

                              <span>
                                Klik semua cek untuk mengakatifkan tombol konfirmasi
                              </span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>

                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">

              <v-btn 
                @click="dialog.status = true; message.error = ''; status = 'konfirmasi pengiriman'"
                :loading="process.load"
                :disabled="process.load"
                v-if="detail.status === 'diterima' && data_bpb.filter(item => !item.is_checked).length < 1"
                width="250"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Konfirmasi Pengiriman
              </v-btn>
              
              <v-btn
                to="/konfirmasi-pengirirman"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false,
          fullscreen: false,
          snackbar: false,
          success: false,
          bukti: false
        },
        status: '',

        detail: {},

        rejected_reason: '',

        form: {
          id: '',
          bpb_arr: []
        },
        category: [],
        branch: [],

        data_bpb: [],

        selected: {
          item: [],
          status: [],
          delete: [],
          export: '',
          detail: []
        },

        mobilephone: {
          name: '',
          id: ''
        },

        summary: [],

        upload: {
          ttd: null,
          image_url: null
        },
        form_update_bpb: {
          bpb_detail_id: '',
          qty_pcs_diterima: 0,
          qty_dus_diterima: 0,
          qty_pcs_return: 0,
          qty_dus_return: 0,
          kirim_qty_dus_rusak: 0,
          bpb_id: '',
          is_close: ''
        },
        process: {
          form: false,

          load: false,

          image_url: false,
          update_bpb: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      toNumber(val) {
        const num = parseFloat(val);
        return isNaN(num) ? 0 : num;
      },
      async fetchDetail (no_reload) {
        this.process.load = no_reload === undefined ? true : false
        let params = {
          id: this.$route.params.id
        }

        await get('admin/surat_jalan/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.bpb_arr = []
            this.data_bpb = []
            this.detail = res.results.data
            res.results.data.bpb.map((item, index) => {
              this.form.bpb_arr.push({
                bpb_id: item.bpb_id,
                bpb_detail: item.detail
              })
            })

            this.form.bpb_arr.map((item, index) => {
              item.bpb_detail.map((items, indexs) => {
                items.bpb_detail_id = items.bpb_detail_id
                items.varian_name = items.varian_name
                items.varian_sku = items.varian_sku
                items.qty_pcs_diterima = items.qty_pcs_diterima
                items.qty_dus_diterima = items.qty_dus_diterima
                items.qty_lusin_diterima = items.qty_lusin_diterima
                items.qty_pcs_return = items.qty_pcs_return
                items.qty_dus_return = items.qty_dus_return
                items.qty_lusin_return = items.qty_lusin_return
              })
            })

            res.results.data.bpb.map((item, index) => {

              item.detail.map((items, indexs) => {
                this.data_bpb.push({
                  ... items,
                  ... item,
                  foto_bukti_json: item.foto_bukti_json !== null && item.foto_bukti_json !== '' ? JSON.parse(item.foto_bukti_json) : [],
                  is_checked: false,
                  is_store_closed: item.is_store_closed,
                  qty_dus_return: item.is_store_closed === '1' ? items.qty_dus_return*1 === 0 && item.kirim_qty_dus_rusak*1 === 0 ? items.qty_dus*1 : items.qty_dus_return*1 : items.qty_dus_return*1,
                  qty_pcs_return: item.is_store_closed === '1' ? items.qty_pcs_return*1 === 0 && item.kirim_qty_dus_rusak*1 === 0 ? items.qty_pcs*1 : items.qty_pcs_return*1 : items.qty_pcs_return*1,
                  qty_tetap: item.qty_dus_muat*1
                })
              })
            })
            this.summarizeByVarian()
          }
          this.process.load = false
        })
      },

      summarizeByVarian() {
        const summaryObj = {};
        const bpbList = this.detail.bpb;

        // bpbList.forEach(bpb => {
          this.data_bpb.forEach(detail => {
            const varianId = detail.varian_id;
            const varianName = detail.varian_name;

            if (!summaryObj[varianId]) {
              summaryObj[varianId] = {
                varian_id: varianId,
                varian_name: varianName,
                total_qty_pcs: 0,
                total_qty_dus: 0,
                total_qty_lusin: 0,
                total_qty_pcs_diterima: 0,
                total_qty_dus_diterima: 0,
                total_qty_lusin_diterima: 0,
                total_qty_pcs_return: 0,
                total_qty_dus_return: 0,
                total_qty_lusin_return: 0,
                total_qty_dus_muat: 0,
                total_qty_dus_rusak: 0,
                total_qty_in_dus: 0
              };
            }

            summaryObj[varianId].total_qty_pcs += Number(detail.qty_pcs);
            summaryObj[varianId].total_qty_dus += Number(detail.qty_dus);
            summaryObj[varianId].total_qty_lusin += Number(detail.qty_lusin);
            summaryObj[varianId].total_qty_pcs_diterima += Number(detail.qty_pcs_diterima);
            summaryObj[varianId].total_qty_dus_diterima += Number(detail.qty_dus_diterima);
            summaryObj[varianId].total_qty_lusin_diterima += Number(detail.qty_lusin_diterima);
            summaryObj[varianId].total_qty_pcs_return += Number(detail.qty_pcs_return);
            summaryObj[varianId].total_qty_dus_return += Number(detail.qty_dus_return);
            summaryObj[varianId].total_qty_lusin_return += Number(detail.qty_lusin_return);
            summaryObj[varianId].total_qty_dus_muat += Number(detail.qty_dus_muat);
            summaryObj[varianId].total_qty_dus_rusak += Number(detail.kirim_qty_dus_rusak);
            summaryObj[varianId].total_qty_in_dus += Number(detail.qty_in_dus);
          });
        // });

        // Convert object ke array
        this.summary = Object.values(summaryObj).reverse();
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      async saveUpdateBpb (index) {
        this.message.error = ''
        const isValid = true
        if (isValid) {
          

        this.process.update_bpb = true

        let url = 'admin/bpb/update_detail'

        await post(url, {
          data: this.form_update_bpb
        }).then(response => {
          let res = response.data

          this.process.update_bpb = false

          if (res.status === 200) {
            this.process.update_bpb = false
            this.data_bpb[index].is_checked = true
            this.data_bpb[index].qty_pcs_diterima = this.form_update_bpb.qty_pcs_diterima
            this.data_bpb[index].qty_dus_diterima = this.form_update_bpb.qty_dus_diterima
            this.data_bpb[index].qty_pcs_return = this.form_update_bpb.qty_pcs_return
            this.data_bpb[index].qty_dus_return = this.form_update_bpb.qty_dus_return
            this.data_bpb[index].kirim_qty_dus_rusak = this.form_update_bpb.kirim_qty_dus_rusak
            this.summarizeByVarian()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      },

      async save () {
        this.message.error = ''
        const isValid = true
        if (isValid) {
          

        this.process.form = true

        let url = 'admin/surat_jalan/confirm'

        await post(url, {
          data: {
            id: this.detail.id
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            this.dialog.success = true
            
            // this.dialog.snackbar = true
            // this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      }
    }
  }
</script>